import { AdvancedSVG, EvolutionSVG, MlSpaceSVG, VmwareSVG } from '@sbercloud/uikit-product-icons';
import cn from 'classnames';

import { PLATFORMS } from '@/constant/common';
import { equals } from '@/utils/common';

import s from './styles.module.scss';

export function IconEnDoc() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='14' height='16' viewBox='0 0 14 16' fill='none'>
      <path
        d='M6.99694 0.973633L13.0818 4.48671V9.26465H11.8818V5.17953L10.5969 4.43773V9.26465H9.39694V3.74491L6.99694 2.35927L2.11211 5.17953V10.82L3.39694 11.5618L3.39694 6.33312H4.59694V12.2547L6.99697 13.6403V15.026L0.912109 11.5129V4.48671L6.99694 0.973633Z'
        fill='#29CC6A'
      />
      <path d='M5.73145 6.7334H8.25879V9.26465H5.73145V6.7334Z' fill='#29CC6A' />
      <path
        d='M8.59863 10.0963L13.0873 10.0963V14.585H11.8873V12.1448L9.02302 15.0091L8.17449 14.1606L11.0388 11.2963H8.59863V10.0963Z'
        fill='#29CC6A'
      />
    </svg>
  );
}

export function PlatformIcon({
  isLarge,
  platform,
  className,
}: {
  isLarge?: boolean;
  platform: string | null;
  className?: string;
}) {
  if (!platform) return null;
  const platformIs = equals(platform);
  const iconClassName = cn(className, s.platform_icon_color);
  const iconSize = isLarge ? 24 : 16;
  if (platformIs(PLATFORMS.evolution)) return <EvolutionSVG className={iconClassName} size={iconSize} />;
  if (platformIs(PLATFORMS.advanced)) return <AdvancedSVG className={iconClassName} size={iconSize} />;

  if (platformIs(PLATFORMS.vmware)) return <VmwareSVG className={iconClassName} size={iconSize} />;

  if (platformIs(PLATFORMS.mlSpace)) return <MlSpaceSVG className={iconClassName} size={iconSize} />;

  return null;
}
